import io from 'socket.io-client';

export default io(process.env.REACT_APP_BAM_WS_URL || '', {
  transports: ['websocket'],
});
